import React from 'react'
import DefaultLayout from '../DefaultLayout'

const CompaniesWrapper = () => {
    const companies = [
        { name: '一般財団法人 産業保健研究財団', imgSrc: '/shkz.png' },
        { name: 'iこころクリニック　日本橋', imgSrc: '/ikokoro_clinic.webp' },
        { name: '大阪大学キャンパスライフ健康支援・相談センター', imgSrc: '/hacc.png' },
        { name: '京都大学', imgSrc: '/kyoto_uni_logo.png' },
        { name: 'えん在宅', imgSrc: '/en_zaitaku_logo.png' },
        { name: '銀座クリニック', imgSrc: '/ginza_clinic_logo.png' },
        { name: '熊本大学病院', imgSrc: '/kumamoto_uni_logo.png' },
    ]
    return (
        <div className='bg-main-100 py-20'>
            <DefaultLayout className='px-6'>
                <div>

                    <h2 className='text-2xl font-semibold mb-8 text-main-800 text-center'>
                        導入事例
                    </h2>
                    <div className='grid sm:flex sm:flex-wrap gap-6'>
                        {companies.map((company, index) => (
                            <div key={index} className='flex items-center justify-center bg-white w-full sm:w-60 h-20 px-4'>
                                <img className='w-full object-contain max-h-[90%]' src={"https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp/" + company.imgSrc} alt={company.name + "様"} width={800} height={250} />
                            </div>
                        ))}
                    </div>

                </div>
            </DefaultLayout>
        </div>
    )
}

export default CompaniesWrapper